export const boundSQL = (geom_table, value) => {
  let subquery = ''
  if (value.includes('All')) {
    subquery = `SELECT the_geom FROM lga_2016_aust
    WHERE lga_name16 = 'Brisbane (C)'`
  } else {
    subquery = `SELECT the_geom FROM ${geom_table}_2016_aust
    WHERE ${geom_table}_name16 = '${value}'`
  }
    const sql = `/* MP - SELECT bounding box */
    SELECT
    ST_XMin(ST_Extent(the_geom)) AS minx,
    ST_YMin(ST_Extent(the_geom)) AS miny,
    ST_XMax(ST_Extent(the_geom)) AS maxx,
    ST_YMax(ST_Extent(the_geom)) AS maxy
    FROM (${subquery}) as subq`;
    //console.log('bound sql', sql)
    return sql;
}

export const sidebarSQL = (geo_type, population, category,  geo_name, data_table) => {
  let extra = '', 
  geo_name_sql = '';

  if (geo_type !== 'Local Government Area') {
    extra = ' ORDER BY value DESC'
  } 
  if (geo_name === 'Brisbane (C)' || geo_name === 'All Suburbs' || geo_name === 'All SA2s') {
    geo_name_sql = ``
  } else {
    geo_name_sql = ` AND geo_name='${geo_name}' `
  }
  let sql =  `
  /* MP - SELECT data to display at the bottom of main search page */
  SELECT geo_name, population, category, geo_type, value as total
  FROM prime_brisbane_${data_table}
  WHERE geo_type='${geo_type}'
  AND population='${population}'
  AND category='${category}' ${geo_name_sql} ${extra}` 
  return queryEscaped(sql);
}


export const populationSQL = (data_table) => {
  const sql =  `  /* MP - Select distinct population */
  SELECT distinct population
  from prime_brisbane_${data_table} order by population desc`
  //console.log('sql', sql)
  return sql;
}

export const categorySQL = (data_table) => {
  const sql = ` /* MP -  Select distinct category, index */
  SELECT distinct category, index
  from prime_brisbane_${data_table}
  order by index asc`
  //console.log('sql', sql)
  return sql;
}

export const geoTypeSQL = (type, data_table) => {
  const sql =  `/* MP - SELECT distinct(geo_name) */
  SELECT distinct(geo_name) FROM prime_brisbane_${data_table}
  WHERE geo_type = '${type}'
  ORDER BY geo_name ASC`
  //console.log('sql', sql)
  return sql;
}

export const dataTablesSQL = (page) => {
  const sql =  `/* MP and EP - SELECT all from  prime_datatable_mapping */
  SELECT  table_group, group_index, display_name, display_index, table_ending, chart_order_clause, chart_heading,
  about_text, summary_heading, summary_content, summary_sort,
  show_table_comparisons, show_table_percentage,
  show_tab_summary, show_tab_chart, show_tab_table, show_tab_about, custom
  FROM prime_datatable_mapping  
  WHERE page='${page}' order by group_index asc, display_index asc`;
  //console.log('dataTablesSQL sql', sql)
  return sql;

}

export const detailChartSQL = (geo_type, population, category, geo_name, data_table, chart_order_clause) => {
//get data for chart
  let query = `/* MP - SELECT data for chart */
  SELECT geo_type, population, category, geo_name, value as total FROM prime_brisbane_${data_table}
  WHERE geo_type = '${geo_type}'
  AND geo_name = '${geo_name}'
  AND population = '${population}'
  AND category != 'Total' ${chart_order_clause}`
  //let updated_sql = query.replace('+', '%2B').replace(/"/g, '\'' );
  //console.log('detailChartSQL query', queryEscaped(query));
  return queryEscaped(query);

}

export const detailTableSQL = (geo_type, population, geo_name, data_table) => {
// get data for table
// percentage from chart and table come from total of table sql
  let geo_name_sql = '';
  if (geo_name === 'Brisbane (C)' || geo_name === 'All Suburbs' || geo_name === 'All SA2s') {
    geo_name_sql = ``
  } else {
    geo_name_sql = ` AND geo_name='${geo_name}' `
  }
  let query = `/* MP - SELECT data for table */
  SELECT cartodb_id as id, geo_type, population, category, geo_name, value as total, index FROM prime_brisbane_${data_table}
  WHERE geo_type = '${geo_type}'
  AND population = '${population}' ${geo_name_sql} order by index asc`

  //let updated_sql = query.replace('+', '%2B').replace(/"/g, '\'' );
  //console.log('detailTableSQL query', queryEscaped(query));
  return queryEscaped(query);

}
export const comparisionSQL = (geo_type, population, data_table) => {
  let where, order;
  if (geo_type === 'Local Government Area') {
    where = ` ('Statistical Area 4', 'State', 'Australia')`
    order = `order by geo_type='Australia', geo_type='State', geo_type='Statistical Area 4', index asc`
  } else {
    where = `('Local Government Area', 'Statistical Area 4', 'State')`
    order = `order by geo_type='State', geo_type='Statistical Area 4', geo_type='Local Government Area', index asc`
  }
  const query = `/* MP - SELECT comparison data for table */  
  SELECT cartodb_id as id, geo_type, population, category, geo_name, value as total, index 
  FROM prime_brisbane_comparisons_${data_table}  
  WHERE geo_type IN ${where}  
  AND population = '${population}'  ${order}`
  //console.log('comparisionSQL', query);
  return queryEscaped(query)
}

export const mapSQL = (geo_type, population, category, geo_name, data_table) => {
  let query='';
  let defaultQuery =  `/* MP - SELECT map data for layer */
      SELECT shape.cartodb_id as cartodb_id,
      shape.the_geom as the_geom,
      shape.the_geom_webmercator as the_geom_webmercator,
      data.geo_type  as geo_type,
      data.geo_name as geo_name,
      data.population as population_type,
      data.category as category,
      data.value as population_value
      FROM prime_brisbane_${data_table} as data, lga_2016_aust as shape
      WHERE category = '${category}'
      AND population = '${population}'
      AND geo_type = 'Local Government Area'
      AND data.geo_code = shape.lga_code16`;
  switch (geo_type) {
      
    case 'Suburb':
      query =  `(${defaultQuery})
      UNION ALL
      (SELECT shape.cartodb_id as cartodb_id, 
      shape.the_geom as the_geom, 
      shape.the_geom_webmercator as the_geom_webmercator,
      data.geo_type as geo_type, 
      data.geo_name as geo_name, 
      data.population as population_type, 
      data.category as category, 
      data.value as population_value
      FROM prime_brisbane_${data_table} as data, ssc_2016_aust as shape 
      WHERE category = '${category}' AND population = '${population}' AND geo_type='${geo_type}' AND
      data.geo_code = shape.ssc_code16 order by value desc)`;
      //console.log('suburb query', query);
      return query;
    case 'Statistical Area 2':
       query = `(${defaultQuery})
      UNION ALL
      (SELECT shape.cartodb_id as cartodb_id, 
      shape.the_geom as the_geom,
      shape.the_geom_webmercator as the_geom_webmercator,
      data.geo_type as geo_type,
      data.geo_name as geo_name,
      data.population as population_type,
      data.category as category, data.value as population_value
      FROM prime_brisbane_${data_table} as data, sa2_2016_aust as shape 
      WHERE category = '${category}' AND population = '${population}' AND data.geo_code = shape.sa2_main16 order by value desc)`;
      //console.log('sa2 map query', query);
      return query;
    default:
      query = defaultQuery
      //console.log('default map query', query);
      return query;
  }
}  


export const mapSQLPlain = (geo_type, population, category, geo_name, data_table) => {
  let query='';
  let defaultQuery =  `/* MP - SELECT map data plain for ajax request */
  SELECT shape.cartodb_id as cartodb_id,
      data.geo_type  as geo_type,
      data.geo_name as geo_name,
      data.population as population_type,
      data.category as category,
      data.value as population_value
      FROM prime_brisbane_${data_table} as data, lga_2016_aust as shape
      WHERE category = '${category}'
      AND population = '${population}'
      AND geo_type = 'Local Government Area'
      AND data.geo_code = shape.lga_code16`;
  switch (geo_type) {
      
    case 'Suburb':
      query =  `(${defaultQuery})
      UNION ALL
      (SELECT shape.cartodb_id as cartodb_id, 
      data.geo_type as geo_type, 
      data.geo_name as geo_name, 
      data.population as population_type, 
      data.category as category, 
      data.value as population_value
      FROM prime_brisbane_${data_table} as data, ssc_2016_aust as shape 
      WHERE category = '${category}' AND population = '${population}' AND geo_type='${geo_type}' AND
      data.geo_code = shape.ssc_code16 order by value desc)`;
      //console.log('suburb query', queryEscaped(query));
      return queryEscaped(query);
    case 'Statistical Area 2':
       query = `(${defaultQuery})
      UNION ALL
      (SELECT shape.cartodb_id as cartodb_id, 
      data.geo_type as geo_type,
      data.geo_name as geo_name,
      data.population as population_type,
      data.category as category, data.value as population_value
      FROM prime_brisbane_${data_table} as data, sa2_2016_aust as shape 
      WHERE category = '${category}' AND population = '${population}' AND data.geo_code = shape.sa2_main16 order by value desc)`;
      //console.log('sa2 map query', queryEscaped(query));
      return queryEscaped(query);
    default:
      query = queryEscaped(defaultQuery)
      //console.log('default map query plain', query);
      return query;
  }
}  
export const cartocss = (layerOpacity, geo_type, geo_name) => {
  let lineWidth = geo_name === 'Brisbane (C)' ? 2 : 5;
  let brisbane_boundary = '';
  
  if (geo_type === 'Statistical Area 2' || geo_type === 'Suburb') {
    brisbane_boundary = `[geo_name='Brisbane (C)'] {
      line-width: 2;
      line-color: #000;
      line-opacity: 1;
      polygon-opacity: 0;
    }`
  }
  let cartoCss =  `
  #layer {
    polygon-fill: ramp([population_value], (#6baed6, #4292c6,#2171b5, #08519c, #08306b), quantiles(5));
    polygon-opacity: ${layerOpacity};
    line-width: 1;
    line-color: #969696;
    line-opacity: ${layerOpacity};
    }
  #layer  {
    [geo_name='${geo_name}'] {
      line-width: ${lineWidth};
      line-color: #eecc04;
      line-opacity: 1;
    }
    ${brisbane_boundary}
  }
    `
    //console.log('cartocss', cartoCss)
  return cartoCss;
}

export const getLayers = ({geo_type, population, category, geo_name, data_table, opacity}) => {

  return  {
      sql: mapSQL(geo_type, population, category, geo_name, data_table.table_ending),
      cartocss: cartocss(opacity, geo_type, geo_name),
      options: {
        featureClickColumns: ["geo_type", "geo_name", "population_type", "population_value", "category"], 
        featureOverColumns: ["geo_type", "geo_name", "population_type", "population_value", "category"]
      },
      visible: true
    }
} 

export const queryEscaped = (query) => {
  const updated_sql = query.replace('+', '%2B').replace(/"/g, '\'' ).replace('&', '	%26');
  return updated_sql
}

export const overviewSummarySQL = (data_table) => {
  //console.log('data_table', data_table)
  let sql 
  if (data_table === 'ep_businessoverview'){
    sql = `/* EP - Select custom business overview summary */
      SELECT category, value, year, type, value, index FROM prime_brisbane_ep_businessoverview
      WHERE category = 'All Industries'
      AND geo_name = 'Brisbane'
      AND year = (SELECT max(year) FROM (SELECT distinct(year) FROM prime_brisbane_ep_businessoverview) as subq)
      AND type IN ('Total','Total Change')
      ORDER BY type ASC`
  } else {
    sql =  `  /* EP - Select custom economic overview summary */
    SELECT category, value, description, source, index
    from prime_brisbane_${data_table}`
  }

  //console.log('sql', sql)
  return sql;
}
export const overviewTable = (data_table) => {
  const sql =  `  /* EP - Select data for overview table */
  SELECT category, output, wages_salaries,value_add, regional_imports, regional_exports, parent_level, key
  from prime_brisbane_ep_overviewtable`
  //console.log('sql', sql)
  return sql;
}


export const businessOverviewSQL = (type, year) => {
  const sql = `/* EP - Select data for business overview for chart */
  SELECT cartodb_id, geo_name, category, year, type, value as total, index
  FROM prime_brisbane_ep_businessoverview
  WHERE type = '${type}'
  AND type != 'Total Change'
  AND geo_name = 'Brisbane'
  AND category != 'All Industries'
  AND year = '${year}'
  ORDER BY index ASC`
  //console.log('sql', sql)
  return sql;
}

export const selectDistinctFromTable = (column, table, where) => {
  const sql = `SELECT distinct(${column})
  FROM ${table}
  ${where}
  ORDER By ${column}`
  //console.log('sql', sql)
  return sql;
}

export const businessOverviewTableSQL = (year) => {
  const sql = `/* EP - Select data for business overview for table */
  SELECT cartodb_id, geo_name, category, year, type, value as total, index 
  FROM prime_brisbane_ep_businessoverview
  WHERE type != 'Total Change'
  AND geo_name = 'Brisbane'
  AND category != 'All Industries'
  AND year = '${year}'
  ORDER BY index ASC`
    //console.log('sql', sql)
    return sql;
}


// WEBPACK FOOTER //
// ./src/sql/queries.js